export class bomBasicInformationType {
    public itemCode: number;
    public itemDescription: string;
    public itemExtendedDescription: string;
    public itemCategory: string;
    public itemGroup: string;
    public manufacturer: string;
    public EANcode: number;
    public salePrice: string;
    public baseCost: string;
    public averageCost: string;
    public itemImage: string;
    public serialNo: boolean;
    public tagNo: boolean;
    public lotNo: boolean;
    public batchNo: boolean;
    public scannableItem: boolean;
    public defaultZone: string;
    public minStockLevel: number;
    public maxStockLevel: number;
    public suggStockLevel: number;
    public itempopularity: string;
    public FLMethod: string;
    public description: string;
    public countryOrigin: string;
    public shelfLife: string;
    public shipLife: string;
    public Qty: string;
    public name: string;
    public typeOfKit: string;


    constructor() {
        this.itemCode = 0;
        this.itemDescription = "";
        this.itemExtendedDescription = "";
        this.itemCategory = "";
        this.itemGroup = "";
        this.manufacturer = "";
        this.EANcode = 0;
        this.salePrice = "";
        this.baseCost = "";
        this.averageCost = "";
        this.itemImage = "";
        this.serialNo = false;
        this.tagNo = false;
        this.lotNo = false;
        this.batchNo = false;
        this.scannableItem = false;
        this.defaultZone = "";
        this.minStockLevel = 0;
        this.maxStockLevel = 0;
        this.suggStockLevel = 0;
        this.itempopularity = "";
        this.FLMethod = "";
        this.description = "";
        this.countryOrigin = "";
        this.shelfLife = "";
        this.shipLife = "";
        this.Qty = "";
        this.name = "";
        this.typeOfKit = "";
    }

}
